import * as Yup from 'yup';
import formScheme from '../formScheme';

const config = {
  0: {
    fields: ['direction'],
    validate: Yup.object().shape({
      direction: Yup.string().required('required'),
    }),
  },
  1: {
    fields: ['direction', 'eventType'],
    validate: Yup.object().shape({
      eventType: Yup.string().required('required'),
    }),
  },
  2: {
    fields: [
      'direction',
      'eventType',
      'responsible',
      'game',
      'platform',
      'dateTime',
      'appVersion',
      'minAppVersion',
      'maxAppVersion',
      'serverVersion',
      'notesLink',
      'description',
      'audience',
      'channel',
      'resolutionDate',
      'techTag',
      'classTag',
      'typeTag',
      'engineVersion',
    ],
    validate: formScheme,
  },
};

export default config;
